/*
 **    库存管理相关
 */
export default [{
        path: 'stockOut',
        name: 'stockOut',
        meta: {
            title: '保税公共仓出库'
        },
        component: () =>
            import( /* webpackChunkName: "pop-deliveredWarn" */ '../views/stockManagement/stockOut/index.vue')
    }, {
        path: 'editStockOut',
        name: 'editStockOut',
        meta: {
            title: '新增或编辑出库单'
        },
        component: () =>
            import( /* webpackChunkName: "pop-deliveredWarn" */ '../views/stockManagement/stockOut/edit/index.vue')
    }, {
        path: 'stockOutDetail',
        name: 'stockOutDetail',
        meta: {
            title: '查看'
        },
        component: () =>
            import( /* webpackChunkName: "pop-deliveredWarn" */ '../views/stockManagement/stockOut/detail/index.vue')
    }, {
    path: 'stockInIndex',
    name: 'stockInForIndex',
    meta: {
        title: '保税公共仓入库'
    },
    component: () =>
        import(/* webpackChunkName: "pop-deliveredWarn" */ '../views/stockManagement/stockIn/index.vue')
    }, {
    path: 'stockIn/add',
    name: 'stockInForAdd',
    meta: {
        title: '创建/编辑入库单'
    },
    component: () =>
        import(/* webpackChunkName: "pop-deliveredWarn" */'../views/stockManagement/stockIn/page/createOrder.vue')
    }
]
